export default __webpack_public_path__ + "static/media/gallery449_2.a98d0709.png";